const translateStatus = (record) => {
  switch (record) {
    case 'pending':
      return 'w toku';
    case 'accepted':
      return 'zaakceptowany';
    case 'rejected':
      return 'odrzucony';
  }
};

export default translateStatus;
